import { style } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';

export const link = style({ color: vars.bright.primary.light, textDecoration: 'underline' });
